<template>
	<div class="networkclass">
		
		<div class="tipcon">
			<div :class="sign == 1?'title_cur':'title'" @click="changetab(1)">鼓号队学习</div>
			<div :class="sign == 2?'title_cur':'title'" @click="changetab(2)">主题队课</div>
		</div>
		
		<div class="listcon">
			<div class="signle" v-for="(item,index) in youthteamllist" :key="index"
			@click="todetail(item)">
				<div class="img_c">
					<el-image fit='cover' :src="$imgUrl + item.cover_dictText" alt=""></el-image>	
				</div>
				<div class="inform_c">
					<div class="title overfh" :title='item.title'>{{item.title || ''}}</div>
					<div class="describe overfh">{{gethypertext(item.introduction)}}</div>
					<div class="time">{{item.createTime || ''}}</div>
				</div>
			</div>
		</div>
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
    return {
        sign:1,
		youthteamllist:[],
	  
    };
  },
  
  mounted() {
		this.getYouthTeam()
  },

  methods: {
		//少年队网络视频
		getYouthTeam(){
			this.$get(`web/teaching/list?pageSize=4&pageNo=1&teachType=${this.sign}`).then(res=>{
				  if(res.success){
						this.youthteamllist = res.result.records
				  }
			})
		},
		
		changetab(sign){
			this.sign = sign
			this.getYouthTeam()
			this.$emit('onChangeTab', this.sign);
		},
		
		todetail(item){
			this.$router.push({ path: '/networkroomdetail?id=' + item.id });
		},
		
		//过滤富文本
		gethypertext(str){
			if(str == null){
				return "";
			}
			var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "").replace(/&rdquo;/gi, "")
			              .replace(/&ldquo;/gi, "").replace(/\n/gi, "").replace(/&hellip;/gi, "").replace(/&mdash;/gi, "");
			// str = str.substring(0,50);
			return str;
		},
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.networkclass{
	
	.tipcon{
		margin:auto;
		margin-top: 60px;
		margin-bottom: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;	
		width:526px;	
		border-radius: 25px;
		.title,.title_cur{
			cursor: pointer;
			width: 253px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 20px;
			font-weight: 400;
			color: #333333;
			border-radius: 25px;
		}
		.title_cur{
			background: #E81414;
			color: #FFFFFF;
		}
		
	}
	
	.listcon{
		margin-top: 40px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.signle{
			cursor: pointer;
			width: 49%;
			overflow: hidden;
			margin-bottom: 20px;
			display: flex;
			flex-wrap: wrap;
			.img_c{
				.el-image{
					width: 183px;
					height: 118px;
				}
			}
			.inform_c{
				margin-left: 20px;
				width: calc(100% - 203px);
				.title{
					font-size: 18px;
					font-weight: 400;
					color: #333333;
					margin-bottom: 10px;
				}
				.describe{
					font-size: 16px;
					font-weight: 400;
					color: #666666;
					// min-height: 70px;
				}
				.time{
					font-size: 14px;
					font-weight: 400;
					color: #666666;
				}
			}
		}
		
	}
	
	
}

</style>
